import React, { useEffect } from 'react';
import HelpLayout from '../../../components/help/HelpLayout';

const SecurityHelp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbs = [
    { name: 'Admin Guide', href: '/help/admin/dashboard' },
    { name: 'Security' }
  ];

  return (
    <HelpLayout title="Security & Best Practices" breadcrumbs={breadcrumbs}>
      <div className="help-content">
        <div className="card">
          <div className="card-body">
            <h2 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: 'var(--primary-black)',
              marginBottom: '16px'
            }}>
              Security & Best Practices Guide
            </h2>
            <p style={{
              fontSize: '16px',
              color: 'var(--text-gray)',
              lineHeight: 1.6
            }}>
              Security guidelines, access control best practices, data protection, and audit trail management.
            </p>

            {/* Data Protection Overview */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                🛡️ Data Protection and Privacy
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  POPIA Compliance
                </h4>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#fee2e2',
                  borderRadius: '6px',
                  border: '1px solid #ef4444',
                  marginBottom: '16px'
                }}>
                  <h5 style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#dc2626',
                    marginBottom: '8px'
                  }}>
                    ⚖️ Protection of Personal Information Act (POPIA)
                  </h5>
                  <p style={{ fontSize: '14px', color: '#dc2626', margin: 0 }}>
                    GMSP3 Career Guidance must comply with South African POPIA regulations for
                    handling personal information of learners and staff.
                  </p>
                </div>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '12px' }}>
                  Key POPIA compliance requirements for the platform:
                </p>
                <ul style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li><strong>Lawful Processing:</strong> Personal information collected only for legitimate GCRA training purposes</li>
                  <li><strong>Consent Management:</strong> Users provide explicit consent for data collection and processing</li>
                  <li><strong>Data Minimization:</strong> Only collect information necessary for training program administration</li>
                  <li><strong>Purpose Limitation:</strong> Use personal information only for stated training and administrative purposes</li>
                  <li><strong>Retention Limits:</strong> Retain personal information only as long as necessary for training purposes</li>
                  <li><strong>Security Safeguards:</strong> Implement appropriate technical and organizational measures</li>
                </ul>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Personal Information Categories
                </h4>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                  gap: '16px',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fee2e2',
                    borderRadius: '6px',
                    border: '1px solid #ef4444'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#dc2626',
                      marginBottom: '8px'
                    }}>
                      🔴 Sensitive Information
                    </h5>
                    <ul style={{ fontSize: '14px', color: '#dc2626', margin: 0, paddingLeft: '16px' }}>
                      <li>South African ID numbers</li>
                      <li>Race and ethnicity data</li>
                      <li>Health information (if applicable)</li>
                      <li>Financial information</li>
                    </ul>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '6px',
                    border: '1px solid #f59e0b'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#d97706',
                      marginBottom: '8px'
                    }}>
                      🟡 Personal Details
                    </h5>
                    <ul style={{ fontSize: '14px', color: '#d97706', margin: 0, paddingLeft: '16px' }}>
                      <li>Names and contact information</li>
                      <li>Addresses and location data</li>
                      <li>Education records</li>
                      <li>Employment history</li>
                    </ul>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#e0f2fe',
                    borderRadius: '6px',
                    border: '1px solid #0284c7'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#0284c7',
                      marginBottom: '8px'
                    }}>
                      🔵 System Data
                    </h5>
                    <ul style={{ fontSize: '14px', color: '#0284c7', margin: 0, paddingLeft: '16px' }}>
                      <li>Login credentials</li>
                      <li>Application history</li>
                      <li>Platform usage data</li>
                      <li>Communication records</li>
                    </ul>
                  </div>
                </div>
              </div>
            {/* Access Control */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                🔐 Access Control and Authentication
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  User Authentication Security
                </h4>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '12px' }}>
                  The platform implements multiple layers of authentication security:
                </p>
                <ul style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li><strong>Password Security:</strong> Enforced strong password requirements</li>
                  <li><strong>Session Management:</strong> Secure session handling with timeout controls</li>
                  <li><strong>Token Authentication:</strong> API access secured with authentication tokens</li>
                  <li><strong>Account Lockout:</strong> Protection against brute force attacks</li>
                  <li><strong>Secure Transmission:</strong> HTTPS encryption for all data transmission</li>
                </ul>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Role-Based Access Control
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#dcfce7',
                    borderRadius: '6px',
                    borderLeft: '4px solid #16a34a'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#16a34a',
                      marginBottom: '4px'
                    }}>
                      👤 Learner Access
                    </h5>
                    <p style={{ fontSize: '14px', color: '#16a34a', margin: 0 }}>
                      Limited to personal profile, course browsing, applications, and dashboard access
                    </p>
                  </div>

                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '6px',
                    borderLeft: '4px solid #f59e0b'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#d97706',
                      marginBottom: '4px'
                    }}>
                      👨‍💼 GCRA Staff Access
                    </h5>
                    <p style={{ fontSize: '14px', color: '#d97706', margin: 0 }}>
                      Application review, course management, student lifecycle management, announcements
                    </p>
                  </div>

                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fee2e2',
                    borderRadius: '6px',
                    borderLeft: '4px solid #ef4444'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#dc2626',
                      marginBottom: '4px'
                    }}>
                      🛡️ System Administrator Access
                    </h5>
                    <p style={{ fontSize: '14px', color: '#dc2626', margin: 0 }}>
                      Full system access, user management, security configuration, data administration
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Audit and Monitoring */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                📋 Audit Trail and Monitoring
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  System Logging
                </h4>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '12px' }}>
                  The platform maintains comprehensive audit trails for security and compliance:
                </p>
                <ul style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li><strong>User Activity Logs:</strong> Login attempts, profile changes, application submissions</li>
                  <li><strong>Administrative Actions:</strong> All admin panel activities and data modifications</li>
                  <li><strong>System Events:</strong> Security events, errors, and system status changes</li>
                  <li><strong>Data Access Logs:</strong> Who accessed what data and when</li>
                  <li><strong>API Usage:</strong> All API calls and responses for system integration</li>
                </ul>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Security Monitoring
                </h4>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                  gap: '16px',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fee2e2',
                    borderRadius: '6px',
                    border: '1px solid #ef4444'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#dc2626',
                      marginBottom: '8px'
                    }}>
                      🚨 Security Alerts
                    </h5>
                    <p style={{ fontSize: '14px', color: '#dc2626', margin: 0 }}>
                      Failed login attempts, suspicious activity, unauthorized access attempts
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '6px',
                    border: '1px solid #f59e0b'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#d97706',
                      marginBottom: '8px'
                    }}>
                      📊 Performance Monitoring
                    </h5>
                    <p style={{ fontSize: '14px', color: '#d97706', margin: 0 }}>
                      System performance, response times, resource utilization
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#e0f2fe',
                    borderRadius: '6px',
                    border: '1px solid #0284c7'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#0284c7',
                      marginBottom: '8px'
                    }}>
                      🔍 Data Integrity
                    </h5>
                    <p style={{ fontSize: '14px', color: '#0284c7', margin: 0 }}>
                      Data validation, consistency checks, backup verification
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Compliance Requirements */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                ⚖️ Compliance and Governance
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Government Compliance
                </h4>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '12px' }}>
                  As a Gauteng Provincial Government initiative, the platform must comply with:
                </p>
                <ul style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li><strong>POPIA (Protection of Personal Information Act):</strong> Data protection and privacy</li>
                  <li><strong>PAIA (Promotion of Access to Information Act):</strong> Information access rights</li>
                  <li><strong>Government IT Security Policy:</strong> Technical security standards</li>
                  <li><strong>GCRA Policies:</strong> Internal governance and operational procedures</li>
                  <li><strong>Skills Development Act:</strong> Training and development compliance</li>
                </ul>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Data Retention and Disposal
                </h4>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#fef3c7',
                  borderRadius: '6px',
                  border: '1px solid #f59e0b',
                  marginBottom: '16px'
                }}>
                  <h5 style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#d97706',
                    marginBottom: '8px'
                  }}>
                    📅 Retention Schedule
                  </h5>
                  <ul style={{ fontSize: '14px', color: '#d97706', margin: 0, paddingLeft: '16px' }}>
                    <li>Active student records: Duration of training + 7 years</li>
                    <li>Application records: 3 years from application date</li>
                    <li>System logs: 2 years for security, 1 year for operational</li>
                    <li>Backup data: Follow primary data retention schedule</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Security Best Practices */}
            <div style={{
              padding: '20px',
              backgroundColor: 'var(--background-gray)',
              borderRadius: '8px',
              marginTop: '32px'
            }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                💡 Security Best Practices
              </h3>
              <ul style={{
                color: 'var(--text-gray)',
                lineHeight: 1.6,
                paddingLeft: '20px',
                margin: 0
              }}>
                <li><strong>Regular security audits:</strong> Conduct quarterly security assessments</li>
                <li><strong>Access reviews:</strong> Review user permissions monthly</li>
                <li><strong>Password policies:</strong> Enforce strong passwords and regular changes</li>
                <li><strong>Data backups:</strong> Maintain secure, tested backup procedures</li>
                <li><strong>Incident response:</strong> Have clear procedures for security incidents</li>
                <li><strong>Staff training:</strong> Regular security awareness training for all users</li>
                <li><strong>Vulnerability management:</strong> Keep systems updated and patched</li>
                <li><strong>Network security:</strong> Implement firewalls and intrusion detection</li>
                <li><strong>Data encryption:</strong> Encrypt sensitive data at rest and in transit</li>
                <li><strong>Compliance monitoring:</strong> Regular compliance assessments and reporting</li>
              </ul>
            </div>

            </div>
          </div>
        </div>
      </div>
    </HelpLayout>
  );
};

export default SecurityHelp;
